import { NgModule } from '@angular/core';

@NgModule({
  providers: [{ provide: Document, useValue: document }],
})
export class DocumentModule {}
